import { render, staticRenderFns } from "./case-section.vue?vue&type=template&id=bd78e020&"
import script from "./case-section.vue?vue&type=script&lang=js&"
export * from "./case-section.vue?vue&type=script&lang=js&"
import style0 from "./case-section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports